/**
 * Reordering an incident's objectives.
 *
 * Kept apart from the table so the move itself is testable: dnd-kit drags are
 * not exercised anywhere in this repo's Storybook, so the arithmetic is what
 * gets covered, the same split `createDraftTemplateOutline.ts` uses.
 */

/**
 * Moves `activeId` to where `overId` currently sits.
 *
 * Returns the original array when either id is unknown or the drop landed back
 * on the row it started from, so callers can skip a pointless write.
 */
export const moveObjective = (
  ids: string[],
  activeId: string,
  overId: string
): string[] => {
  const from = ids.indexOf(activeId);
  const to = ids.indexOf(overId);
  if (from < 0 || to < 0 || from === to) return ids;

  const next = [...ids];
  const [moved] = next.splice(from, 1);
  next.splice(to, 0, moved);
  return next;
};

export default moveObjective;
